export default "__VITE_ASSET__BVGABOmF__"